<template>
    <div class="wrapper">
        <v-layout justify-center>
            <v-container
                    grid-list-md text-xs-center
            >
                <v-layout row wrap pa-2>
                    <v-flex xs12>
                        <v-card
                                class="pa-4"
                                flat
                        >
                            <v-toolbar
                                    dense
                            >
                                <v-text-field
                                        hide-details
                                        single-line
                                        label="staff Name"
                                        v-model="search.name"
                                ></v-text-field>

                                <v-btn
                                        @click="filter_results(search)"
                                        icon
                                        color="blue-grey darken-4">
                                    <v-icon>
                                        mdi-magnify
                                    </v-icon>
                                </v-btn>
                            </v-toolbar>
                        </v-card>
                    </v-flex>

                    <v-flex
                            v-for="(staff, index) in staffs"
                            :key="staff.id"
                            xs12 md4 sm4 lg2 pa-2
                    >
                        <v-card
                                @click="load_customers(staff)"
                        >
                            <v-card-text class="px-0 text-center">
                                {{ staff.name}}
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

        </v-layout>

        <v-dialog v-model="dialog" max-width="400">
            <v-card>
                <edit-data :title="edit_title" :dialog="add_data" :db_link="db_link" :type="form_type" :ed_fields="edit_fields" ></edit-data>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import EditData from '../../../components/c-panel/EditData.vue'

    export default {
        components: {
            EditData
        },
        data () {
            return {
                staffs: [],
                default_edit_fields: [
                    {
                        label: 'Name *',
                        type: 'text',
                        value: '',
                        table:'name',
                        required:true,
                        rules:[]
                    },
                    {
                        label: 'Favourite Products ',
                        type: 'select',
                        options: [],
                        track_by: 'id',
                        async: true,
                        multiple: true,
                        async_url: '/staff/products/?name=',
                        show: 'name',
                        value: [],
                        table: 'products',
                        required: true,
                        allow_new: false,
                        allow_new_table: 'user',
                        allow_new_fields: [],
                        rules: []
                    }
                ],
                form_type: 'new',
                db_link:'',
                edit_fields: [],
                dialog:false,
                show_flash:false,
                flash_message: '',
                flash_type: 'success',
                selected_item: {},
                edit_title: '',
                search:{},
                search_url: ''

            }
        },
        created() {
            this.load_staffs();


        },
        methods: {
            set_dialog(bool)
            {
                this.dialog = bool;
            },
            add_data(response) {
                this.set_dialog(false);
                console.log(response);
                console.log("Close Dialog");
                if(this.form_type === 'new')
                {
                    this.staffs.push(
                        response.data
                    );
                    this.$forceUpdate();
                } else {
                    this.staffs[this.selected_item] = response.data;
                }
            },
            load_customers(s)
            {
                console.log(s);
                localStorage.setItem('language_id', s.language);
                this.$router
                    .push({path: '/c-panel/customers/' + s.id+'/'})
            },
            load_staffs() {

                this.$http.get(this.$http.defaults.baseURL + '/staff/staff-users/'+ this.search_url)
                    .then((response)=>{
                        console.log(response);
                        this.staffs = response.data.results;

                    })
                    .catch((error)=>{
                        console.log("page error");
                        console.log(error);
                    });
            },
            filter_results(search)
            {
                let search_url = '';
                for (let prop in search) {
                    // skip loop if the property is from prototype
                    if(!search.hasOwnProperty(prop)) continue;

                    // your code
                    search_url += '&'+prop+'='+search[prop];
                }
                this.search_url = search_url;
                this.load_staffs();
            }
        }
    }
</script>
